import { render, staticRenderFns } from "./PostSend.vue?vue&type=template&id=4cc2097c&"
import script from "./PostSend.vue?vue&type=script&lang=js&"
export * from "./PostSend.vue?vue&type=script&lang=js&"
import style0 from "./PostSend.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports